import React from "react";

function Logo(props) {
    const height = props.height ? props.height : "20px";
    return (
       <div className={props.className ? props.className : ""} style={{display: "flex", alignItems: "center", height: height}} >
           <svg
                className={props.svgClass ? props.svgClass : ""}
                style={{height: "100%", display: "block"}}
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                strokeLinejoin="round"
                strokeMiterlimit="2"
                clipRule="evenodd"
                viewBox="0 0 22 32"
               //
           >
            <path
                fill="url(#_Linear1)"
                d="M182.511 1069.8a.32.32 0 00-.025-.3.308.308 0 00-.262-.14h-3.049a.305.305 0 00-.286.19l-3.284 7.45a.32.32 0 00.025.3c.057.08.156.14.262.14h3.076a.32.32 0 00.286-.19l3.257-7.45zm-13.655-12.07l-.001.01-.221-.32-.004.01c-.112.31-.209.64-.29.99a5.23 5.23 0 00-.127 1.15c0 .7.14 1.34.417 1.93.282.61.669 1.09 1.155 1.46.515.39 1.099.59 1.754.59h9.041c.212 0 .409.11.524.29.116.17.134.4.049.59l-1.27 2.88a.3.3 0 00.024.29c.058.09.156.15.262.15h3.036c.124 0 .237-.08.287-.19l.684-1.57h-.001l.011-.03c.113-.3.21-.63.291-.99.085-.38.127-.76.127-1.14 0-.7-.14-1.35-.417-1.94a3.872 3.872 0 00-1.155-1.46 2.833 2.833 0 00-1.754-.59h-9.042a.619.619 0 01-.573-.87c.491-1.11 1.271-2.88 1.271-2.88a.317.317 0 00-.024-.3.308.308 0 00-.262-.14h-3.036a.307.307 0 00-.287.19l-.684 1.56.215.33zm1.447-4.14a.32.32 0 00.024.3c.058.09.157.14.262.14h3.05c.124 0 .236-.07.286-.18l3.292-7.45a.322.322 0 00-.024-.3.31.31 0 00-.263-.14h-3.075a.312.312 0 00-.287.18l-3.265 7.45z"
                transform="matrix(.10435 0 0 .10435 -148.597 -67.156) translate(-188.612 -9384.02) scale(9.587)"
            ></path>
            <defs>
                <linearGradient
                id="_Linear1"
                x1="0"
                x2="1"
                y1="0"
                y2="0"
                gradientTransform="scale(32.6275) rotate(14.42 -125.532 34.882)"
                gradientUnits="userSpaceOnUse"
                >
                <stop offset="0" stopColor="#31B3E9"></stop>
                <stop offset="1" stopColor="#455BE8"></stop>
                </linearGradient>
            </defs>
            </svg>
            <span style={{
                fontFamily: "'Barlow', sans-serif",
                fontWeight: 800,
                color: "#566AEA",
                lineHeight: 1,
                whiteSpace: "nowrap",
                fontSize: `calc(${height} * 0.72)`,
                marginLeft: `calc(${height} * 0.15)`,
            }}>4-ward.ai</span>
       </div>
    );
}

export default Logo;
